/**
 * In Store Coupon Module for location fields.
 * Handles all interactions for adding/editing location profiles and templates.
 *
 * @author Billy Bastardi (billy@yext.com)
 */
goog.provide('yext.location.coupon');

goog.require('yext');
goog.require('yext.textutil.CharacterCounter');

/**
 * Coupon is the view controller for the In Store Coupon location field.
 * It handles all interactions for the field.
 */
yext.location.coupon.init = function() {
  yext.location.coupon.ctx = '.js-in-store-coupon-edit';
  yext.location.coupon.$ctx = $(yext.location.coupon.ctx);

  if (!yext.location.coupon.$ctx.length) {
    return;
  }

  // Since we're a singleton and just overwrite existing objects,
  // all we care about is removing the previous bindings to avoid memory leaks.
  yext.location.coupon.cleanBindings();

  yext.location.coupon.sampleCoupon = new yext.location.coupon.SampleCouponViewModel(yext.location.coupon.$ctx);

  // Contains a collection of our character counters
  yext.location.coupon.counters = {
    offerValue: new yext.textutil.CharacterCounter(yext.location.coupon.$ctx.find('[name="inStoreCoupon.offerValue"]'), {
      limit: 15,
    }),
    offerDetail: new yext.textutil.CharacterCounter(yext.location.coupon.$ctx.find('[name="inStoreCoupon.offerDetail"]'), {
      limit: 60,
    }),
  };

  yext.location.coupon.bindToggleBarcodeContent();
  yext.location.coupon.bindDatePicker();
  yext.location.coupon.bindVariousContent();
  yext.location.coupon.bindResetBarcodeVariousContent();
};


/**
 * Support the case where some of the input fields can be indeterminate
 * e.g. Each field has a hidden input [fieldname].indeterminate that gets removed as soon as something is changed.
 * It also supports replacing <Various Content> placeholders with their original value, as long as you add
 * a data-placeholder="original value" attribute to the input
 */
yext.location.coupon.bindVariousContent = function() {
  yext.location.coupon.$ctx.find('input,textarea').on('change', function() {
    var $field = $(this);
    var n = $field.attr('name');
    var $indeterminate = $field.closest('.field-wrap,.text-field').find('[name="'+n+'.indeterminate"]');

    $field.attr('placeholder', $field.data('placeholder') || '');
    if ($indeterminate && $indeterminate.length > 0) {
      $indeterminate.remove();
    }
  });
};

/**
 * Handle various content reset for barcode format field.
 */
yext.location.coupon.bindResetBarcodeVariousContent = function() {
  var $variousWrap = yext.location.coupon.$ctx.find('.radio-various-wrap');
  var $optionsWrap = yext.location.coupon.$ctx.find('.in-store-radio-options-wrap');
  var $barcodeContentWrap = yext.location.coupon.$ctx.find('.in-store-coupon-barcode-content');
  var $barcodeContent = $barcodeContentWrap.find('input[name="inStoreCoupon.barcodeContent"]');

  var isVarious = $variousWrap.length > 0;
  var originalBarcodeContentVal = $barcodeContent.val();

  if (isVarious) {
    yext.location.coupon.$ctx.find('.js-reset-selection').on('click', function() {
      $variousWrap.hide();
      $optionsWrap
        .show()
        .find('input[value="NONE"]')
        .trigger('change');

      $variousWrap.find('input').value('false');

      $barcodeContent.attr('placeholder', '').val('');
      $barcodeContentWrap.hide();
    });

    yext.location.coupon.$ctx.closest('form').find('.js-reset-field').on('click', function() {
      $variousWrap.show();
      $optionsWrap.hide();

      $variousWrap.find('input').value('true');

      $barcodeContent
        .attr('placeholder', $barcodeContent.data('placeholder'))
        .val(originalBarcodeContentVal);
    });
  }
};

/**
 * bindDatePicker handles the datepicker interaction for our expires field
 * @suppress {deprecated}
 */
yext.location.coupon.bindDatePicker = function() {
  yext.location.coupon.$ctx.find('input.date').datepicker({
    minDate: null,
    maxDate: null,
    changeMonth: true,
    changeYear: true,
  });
};

/**
 * bindToggleBarcodeContent will display the BarcodeContent field if necessary,
 * based on the user selection
 */
yext.location.coupon.bindToggleBarcodeContent = function() {
  // Barcode contents should appear for all barcode formats, other than 'None'
  yext.location.coupon.$ctx.find('[name="inStoreCoupon.barcodeFormat"]')
    .on('change.coupon', function() {
      var $self = $(this);
      var $ctx = $self.closest(yext.location.coupon.ctx);

      if ($self.val() === 'NONE') {
        $ctx.find('.in-store-coupon-barcode-content').hide()
          .find('input[name="inStoreCoupon.barcodeContent"]').val('');
      } else {
        $ctx.find('.in-store-coupon-barcode-content').show();
      }
    });
};

/**
 * unbindToggleBarcodeContent handles unbinding the interaction for
 * displaying the BarcodeContent field when the barcodeFormat is changed
 */
yext.location.coupon.unbindToggleBarcodeContent = function() {
  yext.location.coupon.$ctx.find('[name="inStoreCoupon.barcodeFormat"]').off('change.coupon');
};

/**
 * resetCounters provides a way to iterate through all of our 'character counters'
 * and reset them when the coupon field gets reset.
 */
yext.location.coupon.resetCounters = function() {
  for (var c in yext.location.coupon.counters) {
    if (yext.location.coupon.counters[c] instanceof yext.textutil.CharacterCounter) {
      yext.location.coupon.counters[c].reset();
    }
  }
};

/**
 * resetSampleCoupon will reset the SampleCoupon back to it's original state
 */
yext.location.coupon.resetSampleCoupon = function() {
  yext.location.coupon.sampleCoupon.reset();
};

/**
 * cleanBindings will remove all bindings (from the viewModel and the controller)
 */
yext.location.coupon.cleanBindings = function() {
  yext.location.coupon.unbindToggleBarcodeContent();

  if (yext.location.coupon.sampleCoupon instanceof yext.location.coupon.SampleCouponViewModel) {
    yext.location.coupon.sampleCoupon.unbindView();
  }
};

/**
 * SampleCouponViewModel is the glue between the view and the model
 * @param {!jQuery} $ctx The root node that that represents our view
 * @constructor
 */
yext.location.coupon.SampleCouponViewModel = function($ctx) {
  this.$ctx = $ctx || $('.in-store-coupon');

  this.$view = this.$ctx.find('.coupon-sample');
  this.model = this.getNewModelFromDOM(true);

  // Store a copy of the original model, so that we can reset it if necessary
  this.originalModel_ = new yext.location.coupon.SampleCoupon(this.model.getOfferValue(), this.model.getOfferDetail());

  this.bindView();
};

/**
 * bindView will listen for changes on the UI, and then update the sample coupon
 * when changes are detected.
 */
yext.location.coupon.SampleCouponViewModel.prototype.bindView = function() {
  var that = this;

  this.$ctx.find('.js-in-store-banner')
    .off('.couponUpdate')
    .on('paste.couponUpdate keyup.couponUpdate', function() {
      that.updateModel(that.getNewModelFromDOM());
      that.render();
    });
};

/**
 * unbindView removes the event handlers from the UI
 */
yext.location.coupon.SampleCouponViewModel.prototype.unbindView = function() {
  this.$ctx.find('.js-in-store-banner').off('.couponUpdate');
};

/**
 * updateModel will update the existing model with the data from the new SampleCoupon
 * @param {SampleCoupon} sc A SampleCoupon containing the new data
 */
yext.location.coupon.SampleCouponViewModel.prototype.updateModel = function(sc) {
  if (!(sc instanceof yext.location.coupon.SampleCoupon)) {
    throw new Error('SampleCouponViewModel: unable to update model, expected instanceof SampleCoupon.');
  }

  this.model.setOfferValue(sc.getOfferValue());
  this.model.setOfferDetail(sc.getOfferDetail());
};

/**
 * reset Will update the current model with the data from the original model
 */
yext.location.coupon.SampleCouponViewModel.prototype.reset = function() {
  this.updateModel(this.originalModel_);
  this.render();
};

/**
 * render will render the SampleCouponView based on the SampleCoupon model.
 */
yext.location.coupon.SampleCouponViewModel.prototype.render = function() {
  this.$view.find('.js-offer-detail').text(this.model.getOfferDetail());
  this.$view.find('.js-offer-value').text(this.model.getOfferValue());
};

/**
 * getNewModelFromDOM will parse the DOM to find field values that represent the
 * SampleCoupon model, and return a new instance of SampleCoupon containing that data.
 * @param {boolean} isInit indicates if this is an initialization call, which sets the default values different
 */
yext.location.coupon.SampleCouponViewModel.prototype.getNewModelFromDOM = function(isInit) {
  var offerValue = this.$ctx.find('[name="inStoreCoupon.offerValue"]').val();
  var offerValueIndeterminate = this.$ctx.find('[name="inStoreCoupon.offerValue.indeterminate"]').length > 0;
  var offerDetail = this.$ctx.find('[name="inStoreCoupon.offerDetail"]').val();
  var offerDetailIndeterminate = this.$ctx.find('[name="inStoreCoupon.offerDetail.indeterminate"]').length > 0;

  // In the case of initialization when there isn't any headline OR detail set,
  // we default our values to some placeholder values
  if (isInit && (offerValue.length == 0 && offerDetail.length == 0)) {
    if (!offerValueIndeterminate) {
      offerValue = yext.msg('10% off');
    }

    if (!offerDetailIndeterminate) {
      offerDetail = yext.msg('Any in-store purchase');
    }
  }

  if (offerValue.length === 0) {
    if (offerValueIndeterminate) {
      offerValue = yext.msg('<Various Content>');
    } else {
      offerValue = yext.msg('No headline');
    }
  }

  if (offerDetail.length === 0) {
    if (offerDetailIndeterminate) {
      offerDetail = yext.msg('<Various Content>');
    } else {
      offerDetail = yext.msg('No description set');
    }
  }

  return new yext.location.coupon.SampleCoupon(offerValue, offerDetail);
};

/**
 * SampleCoupon Data Model
 * NOTE(billy) Currently a fragment, and only contains fields for the Sample Visualization
 * @constructor
 */
yext.location.coupon.SampleCoupon = function(offerValue, offerDetail) {
  var offerValue_ = offerValue;
  var offerDetail_ = offerDetail;

  this.setOfferValue = function(o) {
    offerValue_ = o;
  };

  this.getOfferValue = function() {
    return offerValue_;
  };

  this.setOfferDetail = function(d) {
    offerDetail_ = d;
  };

  this.getOfferDetail = function() {
    return offerDetail_;
  };
};
